import notificationManager from '../Admin/Signals/SignalEventManager'
import fleetAnalytics from './FleetAnalytics'

export const NotificationManager = notificationManager
export const FleetAnalytics = fleetAnalytics
